import { Avatar } from '@george-labs.com/design-system';

import { TransactionDirection } from '@shared/transactions-types';

import type { IconMapping } from './types';

export const iconsByDirection: IconMapping = {
    [TransactionDirection.INCOMING]: Avatar.ICON.PFM_OTHER_INCOMING,
    [TransactionDirection.OUTGOING]: Avatar.ICON.PFM_OTHER_OUTGOING,
};
